import {useState, useEffect} from 'react'
import secureLocalStorage from 'react-secure-storage'
import {baseUrl} from '../../core'
import usePostApi from '../../custom_hooks/usePostApi'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'

function AssetHr({hrDetails}) {
  const {execute} = usePostApi()
  const {
    approved_status = null,
    approved_comments = '',
    fetchData = () => {},
    employee_asset_id = '',
    assetData,
  } = hrDetails

  let emp_id
  let organization_id
  let role
  let is_hr
  let is_itadmin
  const userInfo = secureLocalStorage.getItem('user_info')
  if (userInfo) {
    ;({emp_id, organization_id, role, is_hr, is_itadmin} = userInfo)
  }

  const intl = useIntl()
  const [hrComment, setHrComment] = useState('')
  const [comError, setComError] = useState(false)
  const [comLenErr, setComLenErr] = useState(false)

  useEffect(() => {
    setHrComment('')

    setComError(false)
    setComLenErr(false)
  }, [])

  useEffect(() => {
    if (hrComment !== '') {
      setComError(false)
    }
    if (hrComment.length >= 3) {
      setComLenErr(false)
    }
  }, [hrComment])

  const approveAndRejectBtns = async (event) => {
    if (hrComment === '') {
      setComError(true)
      return
    } else if (hrComment.length < 3) {
      setComLenErr(true)
      return
    }

    try {
      const url = `${baseUrl}/assetManagement/empAssets/hr/${employee_asset_id}`

      const formData = {
        organization_id: organization_id,
        hr_reviewed_by: emp_id,
        approved_comments: hrComment,
        approved_status: event.target.name,

        request_status: event.target.name,

        approved_employee_id: emp_id,
      }

      // Determine the success message based on the request_status
      await execute(url, 'PATCH', formData)
      fetchData()
      setHrComment('')
      assetData()
      const successMessage =
        event.target.name === 'Approved'
          ? intl.formatMessage({id: 'MSG.REQUEST_APPROVED_SUCCESSFULLY'})
          : intl.formatMessage({id: 'MSG.REQUEST_REJECTED_SUCCESSFULLY'})

      await Swal.fire({
        title: successMessage,
        text: intl.formatMessage({id: 'LABEL.CHANGES_SAVED'}),
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-light-primary btn-sm',
        },
      })
    } catch (error) {
      console.error('Error:', error)
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'LABEL.OOPS'}),
        text: intl.formatMessage({id: 'LABEL.SOMETHING_WRONG'}),
        customClass: {
          confirmButton: 'btn btn-light-primary btn-sm',
        },
      })
    }
  }

  const getHrView = (approvedstatus) => {
    if (approvedstatus === 'Pending' && is_itadmin === 1) {
      return (
        <div className='min-h-26px'>
          <label>{intl.formatMessage({id: 'LABEL.COMMENTS'})}</label>
          <br />
          <textarea
            placeholder={intl.formatMessage({id: 'LABEL.COMMENTS'})}
            className='form-control mb-3 form-control-solid'
            value={hrComment}
            onChange={(e) => setHrComment(e.target.value)}
          />
          {comError && <p className='text-danger'>Comments is Required</p>}
          {comLenErr && !comError && (
            <p className='text-danger'>Comments must be at least 3 characters</p>
          )}
          <div>
            <button
              className='btn btn-light-success btn-sm py-2'
              name='Approved'
              onClick={approveAndRejectBtns}
              type='submit'
              // id='side_activities_close'
            >
              {intl.formatMessage({id: 'LABEL.APPROVE'})}
            </button>
            <button
              className='btn btn-light-danger btn-sm ms-2 py-2'
              name='Rejected'
              onClick={approveAndRejectBtns}
              type='submit'
              // id='side_activities_close'
            >
              {intl.formatMessage({id: 'LABEL.REJECT'})}
            </button>
          </div>
        </div>
      )
    } else if (approvedstatus === 'Approved' || approvedstatus === 'Rejected') {
      return (
        <>
          {/* <p className='m-0 text-muted'>{approved_status}</p> */}
          <p className='m-0 text-muted'>{approved_comments}</p>
        </>
      )
    } else {
      return null
    }
  }

  const getStatusMsg = (approvedstatus) => {
    if (approvedstatus === 'Pending' || approvedstatus === '') {
      return 'Pending'
    } else if (approvedstatus === 'Rejected') {
      return 'Rejected'
    } else if (approvedstatus === 'Approved') {
      return approved_status
    } else {
      return approvedstatus
    }
  }

  const getStatusColor = (approvedstatus) => {
    if (approvedstatus === 'Pending' || approvedstatus === '') {
      return 'muted'
    } else if (approvedstatus === 'Approved') {
      return 'success'
    } else {
      return 'danger'
    }
  }

  return (
    <div className='timeline-item'>
      <div className='timeline-line w-20px'></div>

      <div className='timeline-icon symbol symbol-circle symbol-20px'>
        <div
          className={`symbol-label bg-${getStatusColor(
            approved_status
          )} icon-dotted-border text-${getStatusColor(approved_status)}`}
        ></div>
      </div>

      <div className='timeline-content mb-12 mt-n1'>
        <div className='d-flex justify-content-between mt-1'>
          <p className={`mb-0 fw-bold text-${getStatusColor(approved_status)}`}>
            {getStatusMsg(approved_status)}
          </p>
          <div className=''>
            <p className='designation-btn bg-secondary fs-7 m-auto'>
              {intl.formatMessage({id: 'LABEL.HR'})}
            </p>
          </div>
        </div>
        {getHrView(approved_status)}
      </div>
    </div>
  )
}

export default AssetHr
